export function ErrorAlert({ error, onDismiss }) {
  if (!error) return null;
  const msg = typeof error === 'string' ? error : (error?.message ?? 'An unexpected error occurred');
  return (
    <div className="alert alert-danger" role="alert">
      <span style={{ flex: 1 }}>{msg}</span>
      {onDismiss && (
        <button className="btn-icon" onClick={onDismiss} aria-label="Dismiss error" style={{ padding: 0, marginLeft: 8 }}>
          ✕
        </button>
      )}
    </div>
  );
}
